"use client";

import { Megaphone } from "lucide-react";
import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { useI18n } from "@/locales/client";
import useFeedbackModal from "../hooks/use-feedback-modal";

export const FeedbackButton = () => {
  const { onOpen } = useFeedbackModal();
  const t = useI18n();

  return (
    <SidebarMenuItem>
      <SidebarMenuButton tooltip={t("feedback")} onClick={() => onOpen()}>
        <Megaphone className="size-4" />
        <span>{t("feedback")}</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
